var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescargar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#5E5E5E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_674_1320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.375 10.0752H11.625V12.282H19.375V10.0752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.369 16.9959C19.369 17.1424 19.3127 17.2925 19.1901 17.4208L16.0609 20.6941C15.7655 21.0027 15.2311 21.0027 14.937 20.6941L11.8102 17.4208C11.3996 16.9923 11.7416 16.3313 12.3716 16.3313C12.5886 16.3313 12.7945 16.416 12.9342 16.5625L14.6452 18.3529V14.1608C14.6452 13.7396 15.0289 13.397 15.5008 13.397C15.7373 13.397 15.9506 13.4817 16.105 13.6209C16.2607 13.7589 16.3563 13.949 16.3563 14.1608V18.3517L18.0674 16.5625C18.2083 16.416 18.413 16.3313 18.6287 16.3313C19.07 16.3313 19.3703 16.6545 19.3703 16.9959H19.369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_674_1320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.75,
    height: 10.85,
    fill: "white",
    transform: "translate(11.625 10.0752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescargar);
export default __webpack_public_path__ + "static/media/descargar.a4946803b83879a919052a3070920cf6.svg";
export { ForwardRef as ReactComponent };